import React, { useMemo, useState } from 'react'
import { Stack } from '@mui/material'
import PropTypes from 'prop-types'
import HeadingAndSeeAllLink from '../../../../@rtg2022/components/molecules/HeadingAndSeeAllLink/HeadingAndSeeAllLink'
import {
  Container,
  DesktopTileFlexWrapper,
  MobileGroupWrapper,
  MobileTileFlexWrapper,
  SeeMoreButton,
  SeeMoreWrapper,
} from './index.styles'
import getTiles from './getTiles'
import StrapiHeader from '../Header'

const groupTiles = (tiles, columns) =>
  tiles.reduce((acc, ele, i) => {
    const groupIndex = Math.floor(i / columns)
    if (!acc[groupIndex]) {
      acc[groupIndex] = []
    }
    acc[groupIndex].push(ele)
    return acc
  }, [])

const TileFlex = ({ data }) => {
  const [isCollapsed, setIsCollapsed] = useState(true)

  const tileGridData = data?.TileGrid || {}
  const {
    Heading,
    DisplayHeader,
    ViewAllLink,
    testId,
    Spacing,
    Header,
    DisplayDesktop,
    DisplayMobile,
    MaxNumOfColumnsDesktop,
    NumOfColumnsMobile,
    IsCollapsableDesktop,
    IsCollapsableMobile,
    CollapsedNumOfRowsDesktop,
    CollapsedNumOfRowsMobile,
  } = tileGridData || {}

  const desktopTilewidth = 290
  const mobileTileWidth = 335
  const desktopXPadding = 40
  const desktopTiles = getTiles(tileGridData, desktopTilewidth, true)
  const mobileTiles = getTiles(tileGridData, mobileTileWidth, true)
  const groupedDesktopTiles = useMemo(() => groupTiles(desktopTiles, MaxNumOfColumnsDesktop), [
    desktopTiles,
    MaxNumOfColumnsDesktop,
  ])
  const groupedMobileTiles = useMemo(() => groupTiles(mobileTiles, NumOfColumnsMobile), [
    mobileTiles,
    NumOfColumnsMobile,
  ])
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }
  const canCollapseDesktop = groupedDesktopTiles?.length > CollapsedNumOfRowsDesktop
  const canCollapseMobile = groupedMobileTiles?.length > CollapsedNumOfRowsMobile
  return (
    <Container Spacing={Spacing} DisplayDesktop={DisplayDesktop} DisplayMobile={DisplayMobile} data-testid={testId}>
      {DisplayHeader && !Header && (
        <HeadingAndSeeAllLink
          title={Heading}
          viewAllLink={ViewAllLink}
          headingStyles={{
            fontSize: '25px',
            fontSizeMobile: '20px',
            marginBottom: '35px',
          }}
        />
      )}
      {Header && <StrapiHeader data={Header} />}
      <Stack sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
        {groupedDesktopTiles.map((group, index) => {
          const collapsableButNotCollapsed = IsCollapsableDesktop && !isCollapsed
          if (!IsCollapsableDesktop || collapsableButNotCollapsed)
            return <DesktopTileFlexWrapper desktopXPadding={desktopXPadding}>{group}</DesktopTileFlexWrapper>
          if (IsCollapsableDesktop && isCollapsed) {
            return (
              index < CollapsedNumOfRowsDesktop && (
                <DesktopTileFlexWrapper desktopXPadding={desktopXPadding}>{group}</DesktopTileFlexWrapper>
              )
            )
          }
          return null
        })}
        {IsCollapsableDesktop !== false && canCollapseDesktop && (
          <SeeMoreWrapper>
            <SeeMoreButton href="#" onClick={toggleCollapse}>
              {isCollapsed ? 'See More' : 'See Less'}
            </SeeMoreButton>
          </SeeMoreWrapper>
        )}
      </Stack>
      <Stack sx={{ display: { sm: 'block', md: 'none' } }}>
        <MobileTileFlexWrapper>
          {groupedMobileTiles.map((group, index) => {
            const collapsableButNotCollapsed = IsCollapsableMobile && !isCollapsed
            if (!IsCollapsableMobile || collapsableButNotCollapsed)
              return <MobileGroupWrapper>{group}</MobileGroupWrapper>
            if (IsCollapsableMobile && isCollapsed) {
              return index < CollapsedNumOfRowsMobile && <MobileGroupWrapper>{group}</MobileGroupWrapper>
            }
            return null
          })}
        </MobileTileFlexWrapper>
        {IsCollapsableMobile !== false && canCollapseMobile && (
          <SeeMoreWrapper>
            <SeeMoreButton href="#" onClick={toggleCollapse}>
              {isCollapsed ? 'See More' : 'See Less'}
            </SeeMoreButton>
          </SeeMoreWrapper>
        )}
      </Stack>
    </Container>
  )
}

TileFlex.propTypes = {
  data: PropTypes.object.isRequired,
}
export default TileFlex
